import type {StateCreator} from 'zustand'

export interface LineNumberSelection {
  orientation: 'left' | 'right'
  lineNumber: number | null
  shouldStartConversation: boolean | null
}

export interface LineSelectionSlice {
  lineSelection: {
    firstLineNumberSelection: LineNumberSelection | null
  }
  lineSelectionActions: {
    clearFirstLineNumberSelection: () => void
    setFirstLineNumberSelection: (lineNumberSelection: LineNumberSelection) => void
  }
}

export const createLineSelectionSlice = (): StateCreator<LineSelectionSlice, [['zustand/devtools', never]]> => set => {
  return {
    lineSelection: {
      firstLineNumberSelection: null,
    },
    lineSelectionActions: {
      clearFirstLineNumberSelection: () =>
        set(
          () => ({
            lineSelection: {
              firstLineNumberSelection: null,
            },
          }),
          undefined,
          'clearFirstLineNumberSelection',
        ),
      setFirstLineNumberSelection: (lineNumberSelection: LineNumberSelection) =>
        set(
          () => ({
            lineSelection: {
              firstLineNumberSelection: lineNumberSelection,
            },
          }),
          undefined,
          'setFirstLineNumberSelection',
        ),
    },
  }
}
